import { PSDocumentPage } from './document-page.interface';
import { DocumentClassKey } from '@ps-gui/shared-core';

export interface CurrentPage extends PSDocumentPage {
  previewIndex: number;
}

export type SelectInitialPageBehaviour = 'first' | 'none';

export function fixDocumentClass(documentClass: string): DocumentClassKey {
  if (documentClass === 'AUU' || documentClass === 'AU BESCHEINIGUNG') {
    return '25_Q3_AU_BESCHEINIGUNG';
  }
  if (documentClass === 'BEIHILFEBESCHEID') {
    return '25_Q3_BEIHILFEBESCHEID';
  }
  if (documentClass === 'BERICHT') {
    return '25_Q3_KRANKENHAUS_BERICHT';
  }
  if (documentClass === '301ER_DATEN' || documentClass === '301ER DATEN') {
    return '25_Q3_301ER_DATEN';
  }
  if (documentClass === 'FORDERUNGSAUFSTELLUNG') {
    return '25_Q3_FORDERUNGSAUFSTELLUNG';
  }
  if (documentClass === 'RECHNUNG') {
    return '25_Q3_RECHNUNG';
  }
  if (documentClass === 'SCHADENANZEIGE') {
    return '25_Q3_SCHADENANZEIGE';
  }
  if (documentClass === 'SONSTIGES') {
    return '25_Q3_SONSTIGES';
  }
  if (documentClass === 'VERORDNUNG') {
    return '25_Q3_VERORDNUNG';
  }
  if (documentClass === 'ANSCHREIBEN') {
    return '25_Q3_FORDERUNGSSCHREIBEN';
  }
  return documentClass as DocumentClassKey;
}
